import { render, staticRenderFns } from "./LogVirtualRow.vue?vue&type=template&id=b2c4d618&"
import script from "./LogVirtualRow.vue?vue&type=script&lang=js&"
export * from "./LogVirtualRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports